<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card class="rounded-lg">
      <!-- Loading Overlay -->
      <v-overlay :value="loading" absolute>
        <v-progress-circular
          indeterminate
          size="64"
          color="primary">
        </v-progress-circular>
      </v-overlay>

      <v-card-text class="pa-6">
        <div class="d-flex flex-column align-center text-center">
          <!-- Icon -->
          <div class="mb-4">
            <img
              width="80"
              height="80"
              :src="require('@/assets/svgs/CorrosionAnalyser.svg')"
              alt="Corrosion Analyser" />
          </div>

          <!-- Message -->
          <h3 class="mb-3 text-h6 font-weight-bold">Condition Assessment</h3>
          
          <!-- Initial Message -->
          <p v-if="!completed" class="mb-2 text-body-1">
            Adding these corrosion items to coating analysis for this tag
          </p>
          
          <!-- Success Message -->
          <div v-else class="mb-2">
            <v-icon color="success" size="48" class="mb-2">mdi-check-circle</v-icon>
            <p class="text-body-1 success--text font-weight-medium">
              Successfully added {{ itemCount }} {{ itemCount === 1 ? 'item' : 'items' }} to coating analysis!
            </p>
          </div>
          
          <!-- Count Badge -->
          <v-chip
            v-if="!completed"
            color="primary"
            class="mt-2 mb-4"
            large
            label>
            <v-icon left>mdi-counter</v-icon>
            <span class="font-weight-bold">{{ itemCount }} {{ itemCount === 1 ? 'Item' : 'Items' }}</span>
          </v-chip>
        </div>
      </v-card-text>

      <!-- Action Buttons -->
      <v-card-actions class="px-6 pb-6 pt-0">
        <v-spacer></v-spacer>
        
        <!-- Initial State Buttons -->
        <template v-if="!completed">
          <v-btn
            color="grey"
            text
            class="rounded-pill px-6"
            @click="cancel"
            :disabled="loading">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            class="rounded-pill px-6"
            @click="confirm"
            :loading="loading">
            <v-icon left small>mdi-check</v-icon>
            Confirm
          </v-btn>
        </template>
        
        <!-- Success State Buttons -->
        <template v-else>
          <v-btn
            color="grey"
            text
            class="rounded-pill px-6"
            @click="close">
            Close
          </v-btn>
          <v-btn
            color="primary"
            class="rounded-pill px-6"
            @click="navigateToCorrosionAnalyzer">
            <v-icon left small>mdi-arrow-right</v-icon>
            Go to Coating Analyser
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConditionAssessmentConfirmModal',
  data() {
    return {
      dialog: false,
      itemCount: 0,
      loading: false,
      completed: false,
      resolvePromise: null,
      rejectPromise: null,
    };
  },
  computed:{
facilityId(){
  return this.$route.params.id;
}
  },
  methods: {
    open(count) {
      this.itemCount = count;
      this.dialog = true;
      this.loading = false;
      this.completed = false;

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    confirm() {
      this.loading = true;
      if (this.resolvePromise) {
        this.resolvePromise(true);
      }
      // Don't close immediately - let parent handle state change
    },
    setCompleted() {
      this.loading = false;
      this.completed = true;
    },
    cancel() {
      this.dialog = false;
      if (this.rejectPromise) {
        this.rejectPromise(false);
      }
      this.reset();
    },
    close() {
      this.dialog = false;
      this.reset();
    },
    navigateToCorrosionAnalyzer() {
      this.dialog = false;
      this.reset();
      // Navigate to coating analyzer page
      this.$router.push(`/${this.facilityId}/dashboard/inspection/coating-analyser`);
    },
    reset() {
      this.loading = false;
      this.completed = false;
      this.itemCount = 0;
      this.facilityId = null;
      this.resolvePromise = null;
      this.rejectPromise = null;
    },
  },
};
</script>

<style scoped>
.v-card {
  overflow: hidden;
}
</style>
